import { useParams } from 'react-router-dom';
import { Button } from '@mui/material';
import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';

import { NotificationSeverity, showAlert } from 'utils/notification-manager';

import { StripeCheckoutType } from './checkout-form-container';

type Props = {
  stripeCheckoutType?: StripeCheckoutType;
};

export default function CheckoutForm({ stripeCheckoutType }: Props) {
  const stripe = useStripe();
  const elements = useElements();
  const { portalId } = useParams<Record<string, string>>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    let result;
    if (stripeCheckoutType && stripeCheckoutType === StripeCheckoutType.Setup) {
      result = await stripe.confirmSetup({
        elements: elements,
        confirmParams: {
          return_url: `${window.location.origin}/home/${portalId}/subscription-checkout-success`,
        },
      });
    } else {
      result = await stripe.confirmPayment({
        elements: elements,
        confirmParams: {
          return_url: `${window.location.origin}/home/${portalId}/subscription-checkout-success`,
        },
      });
    }

    if (result.error) {
      showAlert({
        message: 'An issued occurred during checkout: ' + result.error.message,
        severity: NotificationSeverity.ERROR,
      });
      return;
    }

    console.log('Payment succeeded!');
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <Button
        type="submit"
        variant="contained"
        color="primary"
        disabled={!stripe}
        style={{
          marginTop: '10px',
        }}
      >
        Confirm Payment
      </Button>
    </form>
  );
}
